import { z } from 'zod';
import { IDependent } from '../models/Dependent/DependentInterface';

/**
 * Validate dependent information if present
 */
export const dependentValidationSchema = z.object({
  dependents: z.array(
    z.object({
      firstName: z.string().min(2).max(30),
      lastName: z.string().min(2).max(30),
      dateOfBirth: z.string(),
      gender: z.enum(["M", "F"]),
      relationship: z.string()
    }) as z.ZodType<IDependent>
  ).optional()
});